// extracted by mini-css-extract-plugin
export default {"imageContainer":"Kba-z","summaryPar":"Lba-z","ratingCategories":"Mba-z","reviewerInfo":"Nba-z","reviewTypes":"Oba-z","expanded":"Pba-z"};